






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { add, update, details } from '@/api/menu'
import { DetailsResponse } from '../index.d'

@Component({
  name: 'RootModal'
})
export default class extends Vue {
  @Prop({ default: false }) operationDialogFlag!: boolean
  @Prop() id!: number
  @Prop() appId!: number
  private visible = false
  private formParams = {
    activeMenu: 'xxx',
    url: '',
    component: '',
    icon: '',
    isShow: 1,
    name: '',
    pid: 0,
    sort: 0
  }

  private rules = {
    name: [{ required: true, message: '请输入菜单名称', trigger: 'change' }],
    url: [{ required: true, message: '请输入菜单路由', trigger: 'change' }],
    icon: [{ required: true, message: '请输入菜单图标', trigger: 'change' }],
    isShow: [{ required: true, message: '请输选择', trigger: 'change' }]
  }

  private close() {
    this.$emit('update:operationDialogFlag', false);
    (this.$refs.form as ElForm).resetFields()
  }

  private onSubmit() {
    (this.$refs.form as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        this.id ? await update({ ...this.formParams, id: this.id, appId: this.appId }) : await add({ ...this.formParams, appId: this.appId })
        this.id ? this.$message.success('修改成功') : this.$message.success('新增成功')
        this.$emit('onsubmit')
        this.close()
      }
    })
  }

  @Watch('operationDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.operationDialogFlag
    if (this.visible && this.id) {
      // 数据回填
      const { content } = await details<DetailsResponse>({ id: this.id })
      const { name, url, isShow, sort, icon, pid, component } = content
      this.formParams = { ...this.formParams, name, url, isShow, sort, icon, pid, component }
    }
  }
}
